import styled from '../../../utils/styled';
import {keyframes} from 'emotion';

interface CheckboxEffectProps {
  checked?: boolean;
}

const checkboxEffect = keyframes({
  '0%': {
    transform: 'scale(1)',
    opacity: 0.5
  },
  '100%': {
    transform: 'scale(1.6)',
    opacity: 0
  }
});

export default styled('span')<CheckboxEffectProps>(
  {
    position: 'relative',
    margin: 0,
    padding: 0
  },
  ({checked, theme}) => {
    if (checked) {
      return {
        '::after': {
          boxSizing: 'border-box',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          borderRadius: 2,
          border: `1px solid ${theme.color.primary}`,
          content: `''`,
          animation: `${checkboxEffect} 0.36s ease-in-out`,
          animationFillMode: 'both',
          visibility: 'visible'
        }
      };
    }
    return {};
  }
);



// WEBPACK FOOTER //
// ./src/components/Checkbox/private/CheckboxEffect.tsx